import React from 'react';

export default function CatEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="13.36,17.61 8.17,17.61 8.76,13.11 13.96,13.11" fill="#9F8DA7" />
      <polygon points="30.25,17.61 25.05,17.61 25.65,13.11 30.85,13.11" fill="#9F8DA7" />
      <polygon points="37.01,25.26 30.15,23.82 30.15,13.42 37.01,14.86" fill="#6C5974" opacity="0.95" />
      <polygon points="11.6,26.67 2.0,22.69 5.98,13.09 15.58,17.07" fill="#9F8DA7" />
      <polygon points="38.0,22.69 28.4,26.67 24.42,17.07 34.02,13.09" fill="#9F8DA7" />
      <polygon points="14.12,21.59 6.91,18.61 9.9,11.4 17.1,14.39" fill="#9F8DA7" />
      <polygon points="6.91,18.61 6.13,18.22 9.12,11.01 9.9,11.4" fill="#6C5974" opacity="0.95" />
      <polygon points="34.65,18.61 27.45,21.59 24.46,14.39 31.66,11.4" fill="#9F8DA7" />
      <polygon points="27.45,21.59 34.65,18.61 33.87,18.22 26.67,21.2" fill="#6C5974" opacity="0.95" />
      <polygon points="27.45,21.59 26.67,21.2 23.68,14.0 24.46,14.39" fill="#6C5974" opacity="0.95" />
      <polygon points="31.56,21.19 10.78,21.19 10.78,18.59 31.56,18.59" fill="#9F8DA7" />
      <polygon points="10.78,21.19 31.56,21.19 30.0,20.41 9.22,20.41" fill="#6C5974" opacity="0.95" />
      <polygon points="10.78,21.19 9.22,20.41 9.22,17.81 10.78,18.59" fill="#6C5974" opacity="0.95" />
      <polygon points="10.78,28.99 8.18,28.99 8.18,18.59 10.78,18.59" fill="#9F8DA7" />
      <polygon points="8.18,28.99 10.78,28.99 9.22,28.21 6.62,28.21" fill="#6C5974" opacity="0.95" />
      <polygon points="8.18,28.99 6.62,28.21 6.62,17.81 8.18,18.59" fill="#6C5974" opacity="0.95" />
      <polygon points="34.16,28.99 31.56,28.99 31.56,18.59 34.16,18.59" fill="#9F8DA7" />
      <polygon points="31.56,28.99 34.16,28.99 32.6,28.21 30.0,28.21" fill="#6C5974" opacity="0.95" />
      <polygon points="31.56,28.99 30.0,28.21 30.0,17.81 31.56,18.59" fill="#6C5974" opacity="0.95" />
    </svg>
  );
}
